import src from "IMAGE";
export default { src, width: 1180, height: 345, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR42hXKoQ6AIAAFwPdLNoPJTS3OYCKwkan8f+AI1y5JPnZefk4OLgZ5aHQKN5Vt5QmWwATWYQKO1AAAAABJRU5ErkJggg=="};
